import { render, staticRenderFns } from "./MatrixGrid.vue?vue&type=template&id=365b42a4&scoped=true&"
import script from "./MatrixGrid.vue?vue&type=script&lang=js&"
export * from "./MatrixGrid.vue?vue&type=script&lang=js&"
import style0 from "./MatrixGrid.vue?vue&type=style&index=0&id=365b42a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365b42a4",
  null
  
)

export default component.exports